"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconHot = function SvgIconHot(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "hot icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Hot Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.475 4c-.584 3.33-.584 5.635 1.157 8.018 3.881 5.31 8.512 9.789 8.512 16.838C39.144 37.219 32.364 44 24 44c-8.363 0-15.144-6.78-15.144-15.144 0-6.408 4.965-11.861 9.308-16.154-1.203 6.516-.052 10.281 3.453 11.299 5.257 1.525 6.89-2.268 4.454-9.683C23.635 6.899 29.475 4 29.475 4zm-5.123 35.908c5.937 0 10.754-5.4 10.754-10.516 0-2.68-.344-4.213-1.221-6.708 0 7.052-1.363 12.174-7.43 13.893-6.067 1.718-6.76-3.042-8.708-1.382-2.625 2.238 2.61 4.713 6.605 4.713z"
  }));
};

var _default = SvgIconHot;
exports.default = _default;